import Button from '@blocks/Button'
import Form from '@blocks/Form'
import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import useAuth from '@hooks/useAuth'
import React from 'react'
import ClubDelivery from './components/ClubDelivery'

export default function ClubForm({ action, method, handleSuccess, club }: Props) {
    const auth = useAuth<Resources.Customer>()
    
    return (
        <Form action={action} method={method} handleSuccess={handleSuccess}>
            <Grid gap="30px|60px" columns="3">
                <Grid gap="20px">
                    <div>
                        <h3>Info</h3>
                        <p>The information will be displayed only to members and organizers</p>
                    </div>
                    <Input id="name" name="name" label="Name" placeholder="Official Group Name" defaultValue={club?.name} />
                    <Input id="email" name="email" type="email" label="Email" placeholder="group@email.com" comment="Club members and organizers can use it to contact you" defaultValue={club?.email || auth.user.email} />
                </Grid>
                <ClubDelivery club={club} />
                <Grid gap="20px">
                    <div>
                        <h3>Proceed</h3>
                        <small>Note: if you're a head of a group, you can't be a member in another group. But you can delete your group at any time.</small>
                    </div>
                    <Button element="submit">{method === "patch" ? "Save" : "Create"}</Button>
                </Grid>
            </Grid>
        </Form>
    )
}

interface Props {
    method: "post" | "patch"
    action: string
    handleSuccess(club: any): void
    club?: Resources.Club
}